import { X, LayoutDashboard, Building2, Users, Settings, LogOut, Wallet, Activity, AlertTriangle, FileText, ClipboardList, ListChecks, MessageSquare, Target } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';
import { useContext } from 'react';

export default function SidebarSuperAdmin({ sidebarOpen, setSidebarOpen }) {
  const location = useLocation();
  const { logoutUser,hasRole, user } = useContext(AuthContext);



  const generalMenuItems = [
    { label: 'Tableau de bord', icon: LayoutDashboard, path: '/admin-panel' },
    { label: 'Utilisateurs', icon: Users, path: '/admin-panel/users' },
    { label: 'Organisations', icon: Building2, path: '/admin-panel/organizations' },
    { label: 'Abonnements', icon: Wallet, path: '/admin-panel/subscriptions' },
    { label: 'Demande de compte', icon: Building2, path: '/admin-panel/creation-requests' },
    { label: 'Paramètres', icon: Settings, path: '/admin-panel/settings' },
  ]

  const risksMenuItems = [
    { label: 'Risques', icon: AlertTriangle, path: '/admin-panel/risks' },
    { label: 'Activités', icon: ListChecks, path: '/admin-panel/activities' },
    { label: 'Processus', icon: Activity, path: '/admin-panel/processes' },
  ]

  const auditMenuItems = [
    { label: 'Programmes d\'audit', icon: FileText, path: '/admin-panel/audit-programs' },
    { label: 'Plans d\'audit', icon: ClipboardList, path: '/admin-panel/audit-plans' },
    { label: 'Sections d\'audit', icon: ListChecks, path: '/admin-panel/audit-sections' },
    { label: 'Questions d\'audit', icon: MessageSquare, path: '/admin-panel/audit-questions' },
    { label: 'Recommandations', icon: Target, path: '/admin-panel/recommendation-actions' },
  ]




  const handleLogout = () => {
    // Logique de déconnexion ici
    console.log('Déconnexion...');
    logoutUser();
  };

  // Vérifie si le chemin est actif
  const isPathActive = (path) => {
    if (path === '/admin-panel') {
      // For dashboard home, only match exact path
      return location.pathname === path;
    }
    // For other paths, match exact path or sub-paths
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  // Handle menu item click - close sidebar on mobile
  const handleMenuItemClick = () => {
    // Always close sidebar on mobile (simpler and more reliable)
    setSidebarOpen(false);
  };

  return (
    <>
      {/* Barre latérale */}
      <aside
        className={`fixed lg:static top-0 left-0 h-screen w-56 bg-white border-r border-gray-200 z-40 transition-transform duration-300 flex flex-col ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
        }`}
      >
        {/* Section du logo */}
        <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
          <div>
            <h1 className="text-sm font-bold text-gray-900">Cartopousse</h1>
            <p className="text-xs text-gray-400 mt-0.5">Administrateur système</p>
          </div>
          <button
            onClick={() => setSidebarOpen(false)}
            className="lg:hidden p-1 hover:bg-gray-100 rounded transition-colors"
          >
            <X className="h-4 w-4 text-gray-600" />
          </button>
        </div>

        {/* Éléments du menu */}
        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {/* Section Général */}
          <div className="mb-4">
            <h3 className="px-3 text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">
              Général
            </h3>
            {generalMenuItems.map((item, idx) => {
              const Icon = item.icon;
              const active = isPathActive(item.path);

              return (
                <Link
                  key={idx}
                  to={item.path}
                  onClick={handleMenuItemClick}
                  className={`flex items-center space-x-2 px-3 py-2 rounded text-sm transition-colors group
                    ${
                      active
                        ? 'bg-[#0A0A0A] text-[#00C56E] font-semibold'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                >
                  <Icon
                    className={`h-4 w-4 transition-colors ${
                      active ? 'text-white' : 'text-gray-400 group-hover:text-gray-600'
                    }`}
                  />
                  <span className="font-medium text-xs">{item.label}</span>
                </Link>
              );
            })}
          </div>

          {/* Séparateur */}
          <div className="border-t border-gray-200 my-3"></div>

          {/* Section Risques */}
          <div className="mb-4">
            <h3 className="px-3 text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">
              Gestion des Risques
            </h3>
            {risksMenuItems.map((item, idx) => {
              const Icon = item.icon;
              const active = isPathActive(item.path);

              return (
                <Link
                  key={idx}
                  to={item.path}
                  onClick={handleMenuItemClick}
                  className={`flex items-center space-x-2 px-3 py-2 rounded text-sm transition-colors group
                    ${
                      active
                        ? 'bg-[#0A0A0A] text-[#00C56E] font-semibold'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                >
                  <Icon
                    className={`h-4 w-4 transition-colors ${
                      active ? 'text-white' : 'text-gray-400 group-hover:text-gray-600'
                    }`}
                  />
                  <span className="font-medium text-xs">{item.label}</span>
                </Link>
              );
            })}
          </div>

          {/* Séparateur */}
          <div className="border-t border-gray-200 my-3"></div>

          {/* Section Audits */}
          <div className="mb-4">
            <h3 className="px-3 text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">
              Audits
            </h3>
            {auditMenuItems.map((item, idx) => {
              const Icon = item.icon;
              const active = isPathActive(item.path);

              return (
                <Link
                  key={idx}
                  to={item.path}
                  onClick={handleMenuItemClick}
                  className={`flex items-center space-x-2 px-3 py-2 rounded text-sm transition-colors group
                    ${
                      active
                        ? 'bg-[#0A0A0A] text-[#00C56E] font-semibold'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                >
                  <Icon
                    className={`h-4 w-4 transition-colors ${
                      active ? 'text-white' : 'text-gray-400 group-hover:text-gray-600'
                    }`}
                  />
                  <span className="font-medium text-xs">{item.label}</span>
                </Link>
              );
            })}
          </div>
        </nav>

        {/* Bouton de déconnexion */}
        <div className="px-3 py-3 border-t border-gray-100">
          <button
            onClick={handleLogout}
            className="w-full flex items-center space-x-2 px-3 py-2 rounded text-xs font-medium text-red-600 hover:bg-red-50 transition-colors"
          >
            <LogOut className="h-4 w-4" />
            <span>Déconnexion</span>
          </button>
        </div>
      </aside>

      {/* Superposition mobile */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </>
  );
}
